import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ProductsProvider } from '../contexts/ProductsContext';
import { MediaLibraryProvider } from '../contexts/MediaLibraryContext';
import { TagsProvider } from '../contexts/TagsContext';
import { SensorProvider } from '../contexts/SensorContext';
import { DisplaysProvider } from '../contexts/DisplaysContext';

export const BusinessProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { role } = useAuth();

  if (role !== 'business') {
    return <>{children}</>;
  }

  return (
    <TagsProvider>
      <ProductsProvider>
        <MediaLibraryProvider>
          <SensorProvider>
            <DisplaysProvider>
              {children}
            </DisplaysProvider>
          </SensorProvider>
        </MediaLibraryProvider>
      </ProductsProvider>
    </TagsProvider>
  );
};
